<div class="title-container">
  <div class="title">{{ 'WEBSITE_SCRAPE.RESCRAPE_PAGES' | translate }}</div>
  @if (knowledgeSource?.config?.websiteScrapeConfig?.options?.automaticRefreshTime) {
    <mat-icon color="primary">update</mat-icon>
    <div>
      {{
        'WEBSITE_SCRAPE.AUTOMATIC_RESCRAPE_ENABLED'
          | translate
            : {
                date: $safeNavigationMigration(knowledgeSource?.config?.websiteScrapeConfig?.refreshScheduledFor) | date,
              }
      }}
    </div>
  }
</div>
@if (!isLoading()) {
  <mat-dialog-content>
    <div>{{ 'WEBSITE_SCRAPE.RESCRAPE_CONFIRMATION.MESSAGE' | translate }}</div>
    <glxy-form-field bottomSpacing="none">
      <mat-checkbox [formControl]="scrapeAllControl">{{
        'WEBSITE_SCRAPE.RESCRAPE_ALL_PAGES' | translate
      }}</mat-checkbox>
    </glxy-form-field>
    @if (!scrapeAllControl.value) {
      <div class="page-selector">
        <ng-container [formGroup]="form">
          <glxy-form-field formArrayName="scrapedPages">
            <div class="pages-label-container">
              <div class="pages-label">
                {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_PAGES_TO_REFRESH' | translate }}
              </div>
              @if (getScrapedPagesCount() > 1) {
                <div class="controls">
                  <a (click)="setAllScrapedPages(true)">{{
                    'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_ALL' | translate
                  }}</a>
                  |
                  <a (click)="setAllScrapedPages(false)">{{
                    'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_NONE' | translate
                  }}</a
                  >&nbsp;
                  <span
                    >(
                    @if (getScrapedPagesCount() === 1) {
                      {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGE_COUNT_SINGLE' | translate }}
                    } @else {
                      {{
                        'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGE_COUNT'
                          | translate: { scrapedPagesCount: getScrapedPagesCount() }
                      }}
                    }
                    )</span
                  >
                  <span class="selected-count">
                    {{
                      'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.PAGES_SELECTED'
                        | translate: { selectedPagesCount: getSelectedPagesCount() }
                    }}
                  </span>
                </div>
                <glxy-form-field appearance="outline">
                  <glxy-label>Search</glxy-label>
                  <input matInput [formControl]="searchControl" placeholder="Search by title or URL" />
                </glxy-form-field>
              }
            </div>
            <div>
              @for (page of filteredItems; track page) {
                <mat-checkbox [formControl]="getCheckboxControl(page)">
                  {{ page?.title }}
                  <extended>{{ page?.url }}</extended>
                </mat-checkbox>
              }
            </div>
          </glxy-form-field>
        </ng-container>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">
      {{ 'COMMON.CLOSE' | translate }}
    </button>
    <button
      [disabled]="!scrapeAllControl.value && getSelectedPagesCount() < 1"
      mat-flat-button
      color="primary"
      (click)="submit()"
    >
      {{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.REFRESH' | translate }}
    </button>
  </mat-dialog-actions>
} @else {
  <glxy-loading-spinner></glxy-loading-spinner>
}
